import React from 'react';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './UpgradeButton.scss';

interface UpgradeButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function UpgradeButton({ onClick, disabled }: UpgradeButtonProps) {
  const { t } = useTranslation();

  return (
    <button className={s.upgradeButton} onClick={onClick} disabled={disabled}>
      <Box direction="vertical">
        <Text tagName="div" className={s.title}>
          {t('site_preview.cta.title')}
        </Text>

        <Text tagName="div" className={s.description}>
          {t('site_preview.cta.subtitle')}
        </Text>
      </Box>
    </button>
  );
}
